import { render, staticRenderFns } from "./found-problem.vue?vue&type=template&id=72fafd51&scoped=true"
import script from "./found-problem.vue?vue&type=script&lang=js"
export * from "./found-problem.vue?vue&type=script&lang=js"
import style0 from "./found-problem.vue?vue&type=style&index=0&id=72fafd51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fafd51",
  null
  
)

export default component.exports